// Init Api
import initApi from "../api/config";

// Saga effect
import { all, takeLatest } from "redux-saga/effects";

// Services Sagas
import { settingsSagaStart } from "saga/settings";

// Pages Sagas
import { mainSagaStart } from "pages/Main/saga";
import { authSagaStart } from "pages/Auth/saga";
import { ordersStart } from "pages/Orders/saga";
import { pfizerSagaStart } from "../pages/Pfizer/saga";
import { checkoutSagaStart } from "pages/Checkout/saga";
import { projectsSagaStart } from "pages/Projects/saga";
import { searchSagaStart } from "pages/Search/saga/saga";
import { thesaurusSagaStart } from "pages/Thesaurus/saga";
import { librariesSagaStart } from "pages/Libraries/saga";
import { requestSagaStart } from "pages/RequestForm/saga";
import { contactUsSagaStart } from "pages/ContactUs/saga";
import { sagaAccountStart } from "pages/Account/sagas/saga";
import { moleculeProductStart } from "pages/MoleculeProduct/saga";
import { resetPasswordSagaStart } from "pages/ResetPassword/saga";
import { forgotPasswordSagaStart } from "pages/ForgotPassword/saga";
import { chemicalProbesSagaStart } from "../pages/ChemicalProbes/saga";
import { librariesProductSagaStart } from "pages/LibrariesProduct/saga";
import { impuritiesForDrugSagaStart } from "pages/ImpuritiesForDrug/saga";
import { allDrugsVocabularySagaStart } from "pages/AllDrugsVocabulary/saga";
import { librariesCompoundsSagaStart } from "pages/LibrariesCompounds/saga";

/* ------------- Types To Sagas ------------- */
export default function* root(store: object) {
  const Api = initApi(store);

  yield all([
    // Services
    takeLatest("STARTUP", settingsSagaStart, Api),

    // Pages
    takeLatest("STARTUP", ordersStart, Api),
    takeLatest("STARTUP", mainSagaStart, Api),
    takeLatest("STARTUP", authSagaStart, Api),
    takeLatest("STARTUP", pfizerSagaStart, Api),
    takeLatest("STARTUP", searchSagaStart, Api),
    takeLatest("STARTUP", requestSagaStart, Api),
    takeLatest("STARTUP", sagaAccountStart, Api),
    takeLatest("STARTUP", checkoutSagaStart, Api),
    takeLatest("STARTUP", projectsSagaStart, Api),
    takeLatest("STARTUP", librariesSagaStart, Api),
    takeLatest("STARTUP", contactUsSagaStart, Api),
    takeLatest("STARTUP", thesaurusSagaStart, Api),
    takeLatest("STARTUP", moleculeProductStart, Api),
    takeLatest("STARTUP", resetPasswordSagaStart, Api),
    takeLatest("STARTUP", chemicalProbesSagaStart, Api),
    takeLatest("STARTUP", forgotPasswordSagaStart, Api),
    takeLatest("STARTUP", librariesProductSagaStart, Api),
    takeLatest("STARTUP", impuritiesForDrugSagaStart, Api),
    takeLatest("STARTUP", librariesCompoundsSagaStart, Api),
    takeLatest("STARTUP", allDrugsVocabularySagaStart, Api)
  ]);
};
